import React from "react";
import { motion } from "framer-motion";
import { FaWhatsapp, FaFacebookF, FaXTwitter, FaLinkedinIn, FaPinterestP } from "react-icons/fa6";
import "./NttSection.css";
import alumni1 from "../../assets/NIECCE Alumni.avif";
import alumni2 from "../../assets/1.avif";

const AlumniHeroSection = () => {
  return (
    <section className="alumni-section-1">
      <div className="alumni-container-1">
        {/* --- Left Text Section --- */}
        <motion.div
          className="alumni-text-1"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2>
            <span className="blue-text-1">Nursery & Montessori </span>{" "}
            <span className="red-text-1">Teachers Training Course</span>
          </h2>

          <p className="description-1">NIECCE's Nursery & Montessori Teachers Training Course is a comprehensive training program designed to prepare individuals for a fulfilling career in early childhood education. Our program offers value-added programs like Phonics, Puppetry, Storytelling, Rhymes, Handwriting, Pediatric first aid training,  Montessori practicals, physical education, and much more. We also offer placement assistance to our students to help them secure the right job opportunities. Our program is available online, providing the flexibility to learn at your own pace and schedule. Our experienced educators provide mentorship, hands-on experience, and practical training, including real-world teaching experience and classroom observation.</p>
          <p className="description-1">To kickstart your career in early childhood education, join NIECCE's Nursery & Montessori Teachers Training Course today. Our comprehensive program will provide you with the knowledge and skills required to succeed in this dynamic and rewarding field. Contact us now to learn more about our program and how we can help you pursue your passion for teaching young children.</p>

        </motion.div>
        <motion.div
          className="alumni-text-1"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2>
            <span className="red-text-1">Nursery Teachers Training
(Montessori Integrated)</span>
          </h2>

<ul className="description-list">
  <li>Nursery & Montessori Certification (Dual Certificate)</li>
  <li>6 Months Course</li>
  <li>Theory & Practicals Sessions</li>
  <li>Online or Regular Mode</li>
  <li>VAP's with Certification (Value-Added Programs)</li>
  <li>Expert Faculty</li>
  <li>Placement Assistance</li>
  <li>FICS, U.K. Certification (Optional)</li>
  <li>& much more...</li>
</ul>

        </motion.div>
      </div>
    </section>
  );
};

export default AlumniHeroSection;
